function updateTimer (  ) {
	const ele = document.getElementById('time');
	if ( ! ele ) {
		return;
	}
	const time = ele.dataset.time;
	const date = new Date( time );

	let year = date.getFullYear();
	let month = date.getMonth();
	let day = date.getDay();

	setInterval(function () {

		let date_start = new Date(year, month, day);
		let date_now = new Date();

		let seconds = Math.floor(((date_now) - date_start) / 1000);
		let minutes = Math.floor(seconds / 60);
		let hours = Math.floor(minutes / 60);
		let days = Math.floor(hours / 24);

		hours = hours - (days * 24);
		minutes = minutes - (days * 24 * 60) - (hours * 60);
		seconds = seconds - (days * 24 * 60 * 60) - (hours * 60 * 60) - (minutes * 60);

		let innerHTML = "<div class='time-unit'><div class='time-number'>" + days + "</div><div class='time-label'>Days</div></div>";
		innerHTML += 	"<div class='time-unit'><div class='time-number'>" + hours + "</div><div class='time-label'>Hours</div></div>";
		innerHTML += 	"<div class='time-unit'><div class='time-number'>" + minutes + "</div><div class='time-label'>Minutes</div></div>";
		innerHTML += 	"<div class='time-unit'><div class='time-number'>" + seconds + "</div><div class='time-label'>Seconds</div></div>";

		ele.innerHTML = innerHTML;

		}, 1000);
};

updateTimer( );
